import { ArticleService, ReportArticleService } from "@/common/api.service";
import {
  ARTICLES_FETCH,
  REPORT_ARTICLE_ADD,
  REPORT_ARTICLE_DESTROY,
  REPORT_ARTICLES_FETCH
} from "./actions.type";
import {
  ARTICLES_FETCH_END,
  REPORT_ARTICLE_ADDED,
  REPORT_ARTICLE_DESTROYED,
  REPORT_ARTICLES_FETCH_END
} from "./mutations.type";

const SAVING = "saving";
const INVESTING = "investing";
const SPENDING = "spending";

const state = {
  articles: [],
  reportArticles: []
};

function groupBy(array, key) {
  const result = {};
  array.forEach(item => {
    if (!result[item[key]]) result[item[key]] = [];
    result[item[key]].push(item);
  });
  return result;
}

const getters = {
  savingArticles(state) {
    let articles = state.articles.filter(article => {
      return article.category === SAVING && !state.reportArticles.some(a => a.id === article.id)
    });
    return groupBy(articles, "subcategory");
  },
  reportSavingArticles(state) {
    return state.reportArticles.filter(article => article.category === SAVING);
  }
};

const actions = {
  async [ARTICLES_FETCH]({ commit, state }) {
    if (state.articles.length > 0) return;
    return ArticleService.get()
      .then(({ data }) => {
        commit(ARTICLES_FETCH_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [REPORT_ARTICLES_FETCH]({ commit }, reportId) {
    return ReportArticleService.get(reportId).then(({ data }) => {
      commit(REPORT_ARTICLES_FETCH_END, data);
    });
  },
  async [REPORT_ARTICLE_ADD]({ commit }, { reportId, article }) {
    commit(REPORT_ARTICLE_ADDED, article);
    return ReportArticleService.add(reportId, article.id);
  },
  async [REPORT_ARTICLE_DESTROY]({ commit }, { reportId, articleId }) {
    commit(REPORT_ARTICLE_DESTROYED, articleId);
    return ReportArticleService.destroy(reportId, articleId);
  }
};

const mutations = {
  [ARTICLES_FETCH_END](state, articles) {
    state.articles = articles;
  },
  [REPORT_ARTICLES_FETCH_END](state, reportArticles) {
    state.reportArticles = reportArticles;
  },
  [REPORT_ARTICLE_ADDED](state, article) {
    state.reportArticles.push(article);
  },
  [REPORT_ARTICLE_DESTROYED](state, articleId) {
    state.reportArticles = state.reportArticles.filter(
      article => article.id !== articleId
    );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
